export const MAX_PROMO_CODE_LENGTH = 255;
export const ALLOWED_CHARACTERS_REGEX = /^[a-zA-Z0-9_]*$/;
